// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"165":"a9ba9631","176":"f75baeea","629":"31d6cfe0","818":"acedd68d","989":"7c2547f1"}[chunkId] + ".chunk.css";
};